/* eslint-disable no-func-assign */
/* eslint-disable no-undef */
const mapPointsOfInterestWrapper = $("#map-points-of-interest");

var markersArray = [];

function renderMarkers() {
  const pointsData = getPointsData();
  const branches = getPointOfIntereset();

  for (var i = 0; i < branches.length; i++) {
    let marker = addMarker(branches[i], i, pointsData[i].type_of_place);
    markersArray.push(marker);
  }
}

function getPointsData() {
  return mapPointsOfInterestWrapper.data("points");
}

function addMarker(location, index, type) {
  const marker = new google.maps.Marker({
    optimized: false,
    position: location,
    zIndex: type === "property" ? 3 : 1,
    map: mapPointsOfInterest,
    icon:
      "https://s3.eu-central-1.amazonaws.com/vihorev.cz/common/" +
      type +
      "_point.svg"
  });

  marker.addListener("click", () => {
    const infowindow = new google.maps.InfoWindow();
    const pointsData = getPointsData();
    infowindow.setContent(
      "<h4 class='google-map-tooltip'>" +
        pointsData[index].label +
        "<small>" +
        pointsData[index].place_location.name +
        "</small></h4>"
    );
    infowindow.open(mapPointsOfInterest, marker);
    infowindow.set("pixelOffset", new google.maps.Size(10, 10));
  });
  return marker;
}

function getPointOfIntereset() {
  const pointsData = getPointsData();
  const pointsOfInterest = pointsData.map(point => {
    return new google.maps.LatLng(
      point.place_location.latitude,
      point.place_location.longitude
    );
  });

  return pointsOfInterest;
}

function mapPointsOfInterest() {
  const pointsData = getPointsData();

  mapPointsOfInterest = new google.maps.Map(
    document.getElementById("map-points-of-interest"),
    {
      center: {
        lat: pointsData[0].place_location.latitude,
        lng: pointsData[0].place_location.longitude
      },
      zoom: 14,
      disableDefaultUI: true
    }
  );

  google.maps.event.addListener(mapPointsOfInterest, "click", function() {
    infowindow.close(mapPointsOfInterest);
    resetMarkersIcon();
  });

  renderMarkers();
}

$(document).on("click", ".js-map-open", function() {
  google.maps.event.trigger(mapPointsOfInterest, "resize");
  if ($(this).hasClass("is-open")) {
    $(this).removeClass("is-open");
    $(".map-points-of-interest").removeClass("is-open");
  } else {
    $(this).addClass("is-open");
    $(".map-points-of-interest").addClass("is-open");
    const self = this;
    setTimeout(function() {
      $("html,body").animate(
        {
          scrollTop: $(self).offset().top - 70
        },
        1000
      );
    }, 400);
  }
  return false;
});

if (
  mapPointsOfInterestWrapper.length &&
  mapPointsOfInterest &&
  typeof mapPointsOfInterest === "function"
) {
  mapPointsOfInterest();
}
